core.filter('plainText', function() {
        return function(text) {
            return angular.element(text).text();
        }
    }
);
